import "../styles/dashboard.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisEmptyList from "../components/controls/emptylist";
import JisButton from "../components/controls/jisButton";
import JisCheckbox from "../components/controls/jisCheckbox";
import DeadlineBadge from "../components/controls/deadlinebadge";
import ClearOptionsModal from "../components/clearOptionsModal";
import moment from "moment";
import JisDialogForm from "../components/formdialog";
import useComments from "../hooks/useComment";
import Gazette from "../components/core/gazette";

const claimTypes = [
  { id: 1, title: "Mortgage" },
  { id: 2, title: "Liquidated Damage" },
  { id: 3, title: "Foreigner Involved" },
  { id: 4, title: "Non Capital Offense" },
  { id: 5, title: "Non Capital Offense" },
  { id: 6, title: "Other" },
  { id: 7, title: "None" },
];

function Dashboard() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  const [loading, setLoading] = useState(false);
  const [mycases, setMycases] = useState([]);
  const [cases, setCases] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [psaCases, setPsaCases] = useState([]);

  const [acrCases, setAcrCases] = useState([]);
  const [openOption, setOpenOption] = useState(false);
  const [selectedClaimTypes, setSelectedClaimTypes] = useState([]);
  const [isDocPreview, setIsDocPreview] = useState(false);
  const [isRework, setIsRework] = useState(null);
  const [processMode, setProcessMode] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [isLiti, setIsLitiation] = useState(null);
  const [err, setErr] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [cfoSwearingCases, setCfoSwearingCases] = useState([]);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [sheriffs, setSheriffs] = useState([]);
  const [reworkCases, setReworkCases] = useState([]);
  const [adrAdminCases, setAdrAdminCases] = useState([]);
  const [sheriffPendingCases, setSheriffPendingCases] = useState([]);
  const [openCreatePayerIdModal, setOpenCreatePayerIdModal] = useState(false);
  const [openClear, setOpenClear] = useState(false);
  const [clearComment, setClearComment] = useState("");
  const clearCommentRef = useRef(null);
  const [showOngoingCaseDialog, setShowOngoingCaseDialog] = useState(false);
  const [ongoingCaseData, setOngoingCaseData] = useState(null);
  const [isGazette, setIsGazette] = useState(false);
  const FeeTYPEID = 31; // review fee type id
  // Fetch predefined comments
  const { comments: predefinedComments, loading: commentsLoading } =
    useComments(token);

  const CommentDropdown = ({
    setNewValue,
    onChange,
    name,
    placeholder,
    required,
    reasonPlaceHolder,
  }) => {
    const [selectedComments, setSelectedComments] = useState([]);
    const [value, setValue] = useState("");
    // Load predefined selections from value
    useEffect(() => {
      if (value && predefinedComments.length > 0) {
        const parts = value
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean);

        const predefinedSelected = parts.filter((p) =>
          predefinedComments.some((comment) =>
            typeof comment === "string" ? comment === p : comment.source === p,
          ),
        );

        setSelectedComments(predefinedSelected);
      }
    }, [value, setNewValue]);

    // Update parent component - works with both setValue and onChange patterns
    const updateParent = (finalValue) => {
      if (setValue) {
        setValue(finalValue);
      } else if (onChange) {
        onChange({ target: { name, value: finalValue } });
      }
    };

    // Merge and update the parent
    const updateFinal = (updatedSelected, customText) => {
      const cleanedCustom = customText.split(",").map((v) => v.trim());

      const finalValue = [...updatedSelected, ...cleanedCustom]
        .filter(Boolean)
        .join(", ");

      updateParent(finalValue);
    };

    // Handle checkbox change
    const handleCheckboxChange = (e) => {
      const { checked, value: comment } = e.target;

      const updatedSelected = checked
        ? [...selectedComments, comment]
        : selectedComments.filter((c) => c !== comment);

      setSelectedComments(updatedSelected);

      // Get current custom text (non-predefined parts)
      const currentParts = (value || "")
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const customOnly = currentParts.filter(
        (p) =>
          !predefinedComments.some((comment) =>
            typeof comment === "string" ? comment === p : comment.source === p,
          ),
      );

      updateFinal(updatedSelected, customOnly.join(", "));
    };

    // Handle textarea typing
    const handleCustomChange = (e) => {
      const inputText = e.target.value;

      // Update parent immediately for responsive typing
      updateParent(inputText);

      // Update internal selected comments based on what's typed
      const parts = inputText
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const predefinedInText = parts.filter((p) =>
        predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p,
        ),
      );
      setSelectedComments(predefinedInText);
    };

    return (
      <div>
        {reasonPlaceHolder && (
          <p className="reason_placeholder">{reasonPlaceHolder}</p>
        )}
        <div className="predefined_comment_wrapper">
          {predefinedComments.map((comment, index) => {
            const commentText =
              typeof comment === "string" ? comment : comment.source;
            return (
              <label key={index} className="predefined_checkbox_wrapper">
                <input
                  type="checkbox"
                  value={commentText}
                  checked={selectedComments.includes(commentText)}
                  onChange={handleCheckboxChange}
                />
                <p>{commentText}</p>
              </label>
            );
          })}
        </div>

        <div>
          <label style={{ marginBottom: "120px" }} htmlFor="comments">
            comment
          </label>
          <textarea
            className="predefinedComments_textarea"
            ref={clearCommentRef}
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={(e) => handleCustomChange(e)}
          />
        </div>
      </div>
    );
  };

  const [score, setScore] = useState({
    all: 0,
    draft: 0,
    concluded: 0,
    notconcluded: 0,
    commissionedCase: 0,
    pendingCases: 0,
    casesRejected: 0,
    scheduledCases: 0,
  });
  const [casetype, setCaseType] = useState({
    civil: 0,
    criminal: 0,
    motion: 0,
  });
  const [gstatus, setGstatus] = useState("pending");
  const [gradient, setGradient] = useState(`conic-gradient(
    #5CA9FB 0% 30%,
    #FFD964 30% 50%,
    #FF2E3B 50% 100%
  )`);

  useEffect(() => {
    if (profile) {
      console.log(profile, "payer id");
      if (
        ((profile.roleId == 1 || profile.roleId == 2) && profile.payerId == null) ||
        (profile.payerId == "" && (profile.roleId == 1 || profile.roleId == 2))
      ) {
        setOpenCreatePayerIdModal(true);
      }
    }
  }, [profile]);

  useEffect(() => {
    onLoad();
    // Check for ongoing case filing when dashboard loads
    checkForOngoingCase();
    if (profile.role.id === 10) {
      loadAcrCases();
    }
    if (profile.role.id === 1) {
      loadMyCases();
    }

    if (profile.role.id === 8) {
      loadPsaCases();
    }

    if (profile.role.id === 11) {
      loadCfoSwearingCases();
    }

    if (profile.role.id === 18) {
      loadDeputySheriffCases();
      onLoadSheriffByDivision();
    }

    if (profile.role.id === 17) {
      loadProcessedScreenerCases();
    }

    if (
      profile.role.id === 22 ||
      profile.role.id === 23 ||
      profile.role.id === 28
    ) {
      loadAdrAdminCases();
    }

    if (profile.role.id === 19) {
      loadSheriffPendingCases();
    }
  }, []);

  useEffect(() => {
    const all = mycases.reduce((sum, item) => sum + item.allc, 0);

    const civil = mycases
      .filter((e) => e.caseTypeId == 1)
      .reduce((sum, item) => sum + item.allc, 0);
    const criminal = mycases
      .filter((e) => e.caseTypeId == 2)
      .reduce((sum, item) => sum + item.allc, 0);
    const motion = mycases
      .filter((e) => e.caseTypeId == 6)
      .reduce((sum, item) => sum + item.allc, 0);

    setCaseType({ civil: civil, criminal: criminal, motion });
    const civilper = (civil / all) * 100;
    const criminalper = (criminal / all) * 100;
    const motionper = (motion / all) * 100;

    // static calculation

    if (profile.role.id == 1) {
      const val1 = mycases.reduce((sum, item) => sum + item.draft, 0);
      const val2 = mycases.reduce((sum, item) => sum + item.concluded, 0);
      const val3 = mycases.reduce((sum, item) => sum + item.notConcluded, 0);
      setScore({ all: all, draft: val1, concluded: val2, notconcluded: val3 });

      setGradient(`conic-gradient(
    #5CA9FB 0% ${civilper}%,
    #FF2E3B ${civilper}% ${civilper + criminalper}%,
    #FFD964 ${civilper + criminalper}% ${civilper + criminalper + motionper}%
  )`);
    } else {
      const all = mycases.reduce((sum, item) => sum + item.allc, 0);
      const val1 = mycases.reduce((sum, item) => sum + item.pending, 0);
      const val2 = mycases.reduce((sum, item) => sum + item.revised, 0);
      const val3 = mycases.reduce((sum, item) => sum + item.completed, 0);

      setScore({ all: all, pending: val1, revised: val2, completed: val3 });

      setGradient(`conic-gradient(
        #5CA9FB 0% ${civilper}%,
        #FF2E3B ${civilper}% ${civilper + criminalper}%,
        #FFD964 ${civilper + criminalper}% ${
          civilper + criminalper + motionper
        }%
      )`);
    }
  }, [mycases]);

  const checkForOngoingCase = () => {
    const caseinfo = localStorage.getItem("caseinfo");
    if (caseinfo && profile.role.id === 1) {
      // Only for Legal Counsel role
      try {
        const parsedCase = JSON.parse(caseinfo);
        if (parsedCase.userid === profile.id) {
          setOngoingCaseData(parsedCase);
          setShowOngoingCaseDialog(true);
        }
      } catch (error) {
        console.error("Error parsing ongoing case data:", error);
        localStorage.removeItem("caseinfo"); // Clean up corrupted data
      }
    }
  };

  const handleOngoingCaseResponse = (continueCase) => {
    setShowOngoingCaseDialog(false);
    if (continueCase) {
      // Navigate to case filing with preserved data
      navigate("/case-filing");
    } else {
      // Clear the saved data
      localStorage.removeItem("caseinfo");
      setOngoingCaseData(null);
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/report/dashboard/${profile.role.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      console.log(data, "data for debugging");

      setLoading(false);
      if (data.code == 0) {
        setMycases(data.items);
        setDocuments(data.items);
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadSheriffByDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/get-Service-Sheriff`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSheriffs(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const loadAcrCases = async () => {
    try {
      setLoading(true);
      const searchPayload = {
        caseTitle: "",
        caseNumber: "",
        fromDate: "",
        toDate: "",
        filingtype: "all",
        caseprocess: "all",
        caseTypeId: "",
        caseCategoryId: "",
      };

      const resp = await fetch(`${Constants.apiUrl}/filing/acrs/pending/0/3`, {
        method: "POST",
        body: JSON.stringify(searchPayload),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setAcrCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const loadMyCases = async () => {
    const searchPayload = {
      caseTitle: "",
      caseNumber: "",
      fromDate: "",
      toDate: "",
      filingtype: "all",
      caseprocess: "all",
      caseTypeId: "",
      caseCategoryId: "",
    };
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/filing/get-my-cases/0/5`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          body: JSON.stringify(searchPayload),
        },
      });
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const loadPsaCases = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/psa-cases/pending/0/8`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        let filteredCases = data.items;
        filteredCases = data.items.filter(
          (opt) =>
            opt.case?.caseCategoryId !== 4 &&
            opt.case?.processType !== "Fast Track",
        );

        setPsaCases(filteredCases);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onView = (caseid) => {
    navigate(`/case-details/${caseid}`);
  };

  const onPreviewDoc = (docs) => {
    setIsDocPreview(true);
    console.log(docs);
    console.log("here is called");
    var finalpath = "";
    if (docs.documentLocation != null) {
      finalpath = Constants.RelativeFiletoRelative(
        Constants.getDocumentPath(docs)
      );
    } else {
      finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
    }
    setPreviewUrl(finalpath);
  };

  const rework_handleChange = (id, field, value) => {
    setDocuments((prev) =>
      prev.map((d) => (d.id === id ? { ...d, [field]: value } : d)),
    );
  };

  const onGenerateNumber = async (e) => {
    e.preventDefault();
    if (isLiti == null) {
      setErr("Please select the ADR/Litigation option");
      return;
    }
    if (
      option.divisionId == "" ||
      option.subCategoryId == "" ||
      option.caseCategoryId == ""
    ) {
      setErr(
        "Please select from the options of Classification and sub Classification",
      );
      return;
    }
    setErr("");
    var approve = { ...option, isLitigation: isLiti, source: "acr" };

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/generate-suit-number`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setSuitnumber(data.suit);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onSave = async (e) => {
    e.preventDefault();

    if (isLiti == null) {
      setErr("Please select the Approval Option");
      return;
    }
    if (isLiti == false && isRework == null) {
      setErr("Please select the Reject Option");
      return;
    }
    if (isLiti == true && suitNumber == "") {
      setErr("Please generate Suit Number to Preview first");
      return;
    }

    var claimtypes = Array.from(selected);
    setErr("");

    var approve = {
      ...option,
      isLitigation: isLiti,
      suitNumber: suitNumber,
      source: "acr",
      claimtypes: claimtypes,
      processType: processMode,
    };
    if (isRework == true) {
      const rw = documents
        .filter((d) => d.isLegal || d.isCfo)
        .map((d) => ({
          docid: d.id,
          isLegal: d.isLegal || false,
          isCfo: d.isCfo || false,
          comment: d.comment || "",
          docTitle: d.title || "",
        }));

      approve.reworks = rw;
    }

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-litigation-approval`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        const ft = cases.filter((_, i) => i !== index);
        setCases(ft);
        if (isLiti == false) {
          setAlert({
            open: true,
            title: "Option",
            subtitle: "rejected successfully",
          });
        } else {
          setAlert({
            open: true,
            title: "Option",
            subtitle: "accepted successfully",
          });
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onAdrLitigation = (cc, ind) => {
    setActive(cc);
    setIndex(ind);
    setOpenOption(true);
    setOption({
      caseId: cc.caseId,
      caseCategoryId: cc.caseCategoryId,
      divisionId: cc.divisionId,
    });
    setSuitnumber("");
    setProcessMode(cc.processType);
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  console.log(profile.role, "profile role id ");

  const loadCfoSwearingCases = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/eswearing-cfo-cases/pending/0/6`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            caseTitle: "",
            caseNumber: "",
            fromDate: "",
            toDate: "",
            filingtype: "all",
            caseprocess: "all",
            caseTypeId: "",
            caseCategoryId: "",
          }),
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCfoSwearingCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const loadDeputySheriffCases = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/service-sheriff/pending/0/6`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            caseTitle: "",
            caseNumber: "",
            fromDate: "",
            toDate: "",
            filingtype: "all",
            caseprocess: "all",
            caseTypeId: "",
            caseCategoryId: "",
          }),
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const assignDsCase = async (e) => {
    e.preventDefault();
    console.log("testing one two");
    console.log(option);

    if (option.roleId == "") {
      setErr("Please selecte one of the listed Service Sherrif");
      return;
    }

    var caseids = Array.from(selected);
    setErr("");
    //var judgeAs=isCmc==true?'CMC':'Trial';
    var approve = {
      ...option,
      caseids: caseids,
      assignType: "service-sheriff",
      assignTo: option.roleId,
    };
    console.log(approve);

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
        method: "POST",
        body: JSON.stringify(approve),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        setSelected(new Set());
        setAlert({
          open: true,
          title: "Deputy Sheriff Assignment",
          subtitle: "Cases assigned successfully",
        });
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const handleNavigate = () => {};
  const loadProcessedScreenerCases = async () => {
    try {
      setLoading(true);
      const searchPayload = {
        caseTitle: "",
        caseNumber: "",
        fromDate: "",
        toDate: "",
        filingtype: "all",
        caseprocess: "all",
        caseTypeId: "",
        caseCategoryId: "",
      };

      const resp = await fetch(
        `${Constants.apiUrl}/filing/screeners/processed/0/5`,
        {
          method: "POST",
          body: JSON.stringify(searchPayload),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setReworkCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const loadAdrAdminCases = async () => {
    const caseStatusId =
      profile.role.id === 23 ? 157 : profile.role.id === 28 ? 113 : 88;
    try {
      setLoading(true);
      const searchPayload = {
        caseTitle: "",
        caseNumber: "",
        fromDate: "",
        toDate: "",
        filingtype: "all",
        caseprocess: "all",
        caseTypeId: "",
        caseCategoryId: "",
      };

      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-admin-cases/${caseStatusId}/0/5`,
        {
          method: "POST",
          body: JSON.stringify(searchPayload),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setAdrAdminCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onConfirmFee = (item, ind) => {
    setActive(item);
    setIndex(ind);
    setIsGazette(true);
  };

  const onGazetteProceed = (e) => {
    console.log("after processing gazette... here is value");
    console.log(e);

    const ft = psaCases.filter((_, i) => i !== index);
    setPsaCases(ft);
    setIsGazette(false);
    setAlert({
      open: true,
      title: "Fee Confirmation",
      subtitle: "Fee confirmed successfully",
    });
  };

  const onClear = (item) => {
    setActive(item);
    setOpenClear(true);
  };

  const onSaveClear = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-clear-case/pending/${active.caseId}`,
        {
          method: "POST",
          body: JSON.stringify({
            caseid: active.caseId,
            comment: clearComment,
          }),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setOpenClear(false);
        setAlert({
          open: true,
          title: "Case Acceptance",
          subtitle: "Case cleared successfully",
        });
        loadAdrAdminCases(); // Reload the cases
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const loadSheriffPendingCases = async () => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/service-sheriff/assigned/0/5`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSheriffPendingCases(data.items);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div>
      <div className="dashboard">
        <div className="main-row">
          {profile.role.id == 1 && (
            <div className="left-cards">
              <div className="card">
                <div className="card-icon">
                  <DynamicIcon iname="book-open" size={24} color={"white"} />
                </div>
                <div>Total Cases</div>
                <div className="card-value">{score.all + score.draft}</div>
              </div>
              <div className="card">
                <div className="card-icon">
                  <DynamicIcon iname="book-open" size={24} color={"white"} />
                </div>
                <div>Ongoing Cases</div>
                <div className="card-value">{score.notconcluded}</div>
              </div>
              <div className="card">
                <div className="card-icon">
                  <DynamicIcon iname="book-open" size={24} color={"white"} />
                </div>
                <div>Concluded Cases</div>
                <div className="card-value">{score.concluded}</div>
              </div>
              <div className="card">
                <div className="card-icon">
                  <DynamicIcon iname="book-open" size={24} color={"white"} />
                </div>
                <div>Draft</div>
                <div className="card-value">{score.concluded}</div>
              </div>
            </div>
          )}

          {profile.role.id != 1 && (
            <div className="left-cards">
              <div className="card">
                <div className="card-icon">
                  <DynamicIcon iname="book-open" size={24} color={"white"} />
                </div>
                <div>
                  {profile.role.id === 11 ||
                  profile.role.id === 18 ||
                  profile.role.id === 24
                    ? "Total cases"
                    : "New Cases"}
                  {/* {(profile.role.id === 10 || profile.role.id === 8) && "Today"} */}
                </div>
                <div className="card-value">
                  {profile.role.id === 11 ? score.all : score.pending}
                </div>
              </div>

              {profile.role.id !== 18 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="book-open" size={24} color={"white"} />
                  </div>
                  <div>
                    {profile.role.id === 11
                      ? "Scheduled Cases"
                      : "Pending Cases"}
                  </div>
                  {profile.role.id === 11 || profile.role.id === 24 ? (
                    <div className="card-value">
                      {profile.role.id === 24
                        ? Number(score.revised) || 0
                        : score.scheduledCases || 0}
                    </div>
                  ) : (
                    <div className="card-value" style={{ color: "red" }}>
                      {Number(score.revised) || 0}
                    </div>
                  )}
                </div>
              )}

              {profile.role.id !== 18 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="book-open" size={24} color={"white"} />
                  </div>
                  <div>
                    {profile.role.id === 11
                      ? "Commissioned Cases"
                      : profile.role.id === 24
                        ? "Concluded Cases"
                        : "Processed Cases"}
                  </div>
                  <div className="card-value">
                    {profile.role.id === 11
                      ? score.commissionedCase || 0
                      : score.completed || 0}
                  </div>
                </div>
              )}
              {profile.role.id === 18 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon
                      iname="circle-check"
                      size={24}
                      color={"white"}
                    />
                  </div>
                  <div>Assigned Cases</div>
                  <div className="card-value">
                    {profile.role.id === 11
                      ? score.commissionedCase || 0
                      : score.completed}
                  </div>
                </div>
              )}
              {profile.role.id === 18 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon
                      iname="circle-check"
                      size={24}
                      color={"white"}
                    />
                  </div>
                  <div>ADR Cases Assigned</div>
                  <div className="card-value">
                    {profile.role.id === 11
                      ? score.commissionedCase || 0
                      : score.completed}
                  </div>
                </div>
              )}

              {profile.role.id !== 18 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="book-open" size={24} color={"white"} />
                  </div>
                  <div>
                    {profile.role.id === 11
                      ? "Pending Cases"
                      : " Flagged Cases"}
                  </div>
                  {profile.role.id === 11 ? (
                    <div className="card-value">{score.pendingCases || 0}</div>
                  ) : (
                    <div className="card-value" style={{ color: "red" }}>
                      0
                    </div>
                  )}
                </div>
              )}
              {profile.role.id === 18 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="clock" size={24} color={"white"} />
                  </div>
                  <div>Motion Cases Assigned</div>
                  <div className="card-value">{score.casesRejected || 0}</div>
                </div>
              )}
              {profile.role.id === 11 ||
                (profile.role.id === 18 && (
                  <div className="card">
                    <div className="card-icon">
                      <DynamicIcon
                        iname="book-open"
                        size={24}
                        color={"white"}
                      />
                    </div>
                    <div>Case Rejected</div>
                    <div className="card-value">{score.casesRejected || 0}</div>
                  </div>
                ))}
              {profile.role.id === 24 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="book-open" size={24} color={"white"} />
                  </div>
                  <div>Cases Assigned</div>
                  <div className="card-value">
                    {score.commissionedCase || 0}
                  </div>
                </div>
              )}
              {profile.role.id === 24 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="book-open" size={24} color={"white"} />
                  </div>
                  <div>Cases Not Assigned</div>
                  <div className="card-value">{score.notconcluded || 0}</div>
                </div>
              )}

              {profile.role.id === 10 && (
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="book-open" size={24} color={"white"} />
                  </div>
                  <div>Total Cases</div>
                  <div className="card-value">{score.all}</div>
                </div>
              )}
            </div>
          )}
        </div>

        {profile.role.id == 1 && (
          <div className="mid-section">
            <div className="overview">
              <div className="chart-area">
                <h4>Filing Overview</h4>
                <div
                  className="holeGraph"
                  style={{
                    background: gradient,
                    height: "303px",
                    width: "303px",
                    borderRadius: "50%",
                    marginTop: "10px",
                  }}
                >
                  <div className="pie-red"></div>
                </div>
              </div>
              <div className="case-summary">
                <div className="summary-box">
                  <div className="in-summary-box">
                    <div
                      className="circle-only"
                      style={{ backgroundColor: "var(--primary)" }}
                    ></div>
                    <div>Civil</div>
                  </div>

                  <p>{casetype.civil}</p>
                </div>
                <div className="summary-box">
                  <div className="in-summary-box">
                    <div
                      className="circle-only"
                      style={{ backgroundColor: "red" }}
                    ></div>
                    <div>Criminal </div>
                  </div>
                  <p>{casetype.criminal}</p>
                </div>
                <div className="summary-box">
                  <div className="in-summary-box">
                    <div
                      className="circle-only"
                      style={{ backgroundColor: "orange" }}
                    ></div>
                    <h3 style={{ color: "orange" }}>Motion</h3>
                  </div>

                  <p>{casetype.motion}</p>
                </div>
              </div>
            </div>
            <div className="stati">
              <div className="stati-title">Case Statistics</div>

              <div className="stati-wrapper">
                <div className="stati-box">
                  <div className="stati-box-value">
                    {score.all + score.draft} cases opened this month
                  </div>
                  <div className="stati-box-past">0% vs last month 0</div>
                </div>
                <div className="stati-box">
                  <div className="stati-box-value">
                    {score.notconcluded} cases pending hearing
                  </div>
                  <div className="stati-box-past">0% vs last month 0</div>
                </div>
                <div className="stati-box">
                  <div className="stati-box-value">
                    {score.concluded} cases concluded this month
                  </div>
                  <div className="stati-box-past">0% vs last month 0</div>
                </div>
                <div className="stati-box">
                  <div className="stati-box-value">
                    {score.draft} cases in draft
                  </div>
                  <div className="stati-box-past">0% vs last month 0</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {profile.role.id != 1 && (
          <div
            className="case_overview"
            style={{
              display: "flex",
              marginTop: 20,
              flexDirection: "column",
              gap: 16,
            }}
          >
            <div className="case_title">Case Overview</div>
            <div className="chart_section">
              <div>
                <div
                  className="holeGraph"
                  style={{
                    background: gradient,
                    height: "300px",
                    width: "300px",
                    borderRadius: "50%",
                    marginTop: "10px",
                  }}
                ></div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 32,
                }}
              >
                {/* <div class="radio-group">
                  <label
                    className="radioeffect"
                    onClick={() => setGstatus("approved")}
                  >
                    {" "}
                    <span>
                      <input
                        type="radio"
                        className="radio_dot"
                        name="cases_overview"
                      />
                      { <DynamicIcon
                      size={32}
                      iname={`${
                        gstatus == "approved" ? "circle-check" : "circle"
                      }`}
                      color={`${
                        gstatus == "approved" ? "var(--primary)" : "var(--text)"
                      }`}
                    /> }
                    </span>
                    <span>
                      {profile.role.id === 18
                        ? "Cases Commissioned "
                        : "Cases Approved"}
                    </span>{" "}
                  </label>
                  <label
                    className="radioeffect"
                    onClick={() => setGstatus("pending")}
                  >
                    <span>
                      <input
                        type="radio"
                        className="radio_dot"
                        name="cases_overview"
                      />

                      { <DynamicIcon
                      iname={`${
                        gstatus == "pending" ? "circle-check" : "circle"
                      }`}
                      color={`${
                        gstatus == "pending" ? "var(--primary)" : "var(--text)"
                      }`}
                    /> }
                    </span>
                    <span>
                      {profile.role.id === 18
                        ? "Scheduled Cases"
                        : "Pending Cases"}
                    </span>
                  </label>
                </div> */}
                <div>
                  <ul class="legend">
                    <li>
                      <span class="box civil"></span> Civil Cases
                    </li>
                    <li>
                      <span class="box criminal"></span> Criminal Cases
                    </li>
                    <li>
                      <span class="box motion"></span> Motion
                    </li>
                    {(profile.role.id === 11) | (profile.role.id === 18) ? (
                      <li>
                        <span class="box affidavit"></span> Affidavit
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        {profile.role.id === 10 && (
          <div className="table" style={{ marginTop: 20 }}>
            <div class="section-cases">
              <span>New Cases</span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-medium">Classification</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-medium">Status Level</th>
                    <th>SLA</th>
                    <th className="col-title">Details</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {acrCases?.map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.referenceNumber || "N/A"}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId,
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.caseStatusId,
                        )?.description || "N/A"}
                      </td>
                      <td>
                        <DeadlineBadge dateString={opt.slaExpire} />
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onView(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onAdrLitigation(opt, index)}
                        >
                          Clear
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {(profile.role.id == 1 || profile.role.id == 15) && (
          <div className="table" style={{ marginTop: 24 }}>
            <div class="table-header">
              <span>Recent Cases </span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-medium">Classification</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-medium">Status Level</th>
                    <th className="col-title">Details</th>
                  </tr>
                </thead>
                <tbody>
                  {cases?.map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.caseNumber ?? opt.referenceNumber}{" "}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId,
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.caseStatusId,
                        )?.description || "N/A"}
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onView(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {profile.role.id === 8 && psaCases?.length > 0 && (
          <div className="table" style={{ marginTop: 20 }}>
            <div class="section-cases">
              <span>New Cases</span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-medium">Classification</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-medium">Status Level</th>
                    <th>SLA</th>
                    <th>Fee</th>
                    <th className="col-title">Details</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {psaCases?.slice(0, 3).map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.case?.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.case.caseNumber ?? opt.case.referenceNumber}
                      </td>
                      <td>{opt.case?.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.case?.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.case?.caseCategoryId,
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.case?.caseStatusId,
                        )?.description || "N/A"}
                      </td>
                      <td>
                        <DeadlineBadge dateString={opt.case?.slaExpire} />
                      </td>
                      <td>
                        {opt.fee
                          ? `₦${Constants.formatCurrency(opt.fee)}`
                          : "N/A"}
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onView(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onConfirmFee(opt, index)}
                        >
                          Update <br />/<br />
                          Confirm Fee
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {profile.role.id === 11 && cfoSwearingCases?.length > 0 && (
          <div className="table" style={{ marginTop: 20 }}>
            <div class="section-cases">
              <span>New Cases</span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th>Suite Number</th>
                    <th className="col-title">Case Title</th>
                    <th>Status</th>
                    <th className="col-medium">Schedule Date</th>
                    <th>Time</th>
                    <th className="col-title">Zoom Link</th>
                    <th className="col-action">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {cfoSwearingCases?.slice(0, 6).map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              item.case.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {item.case.caseNumber ?? item.case.referenceNumber}
                      </td>
                      <td>{item.case.caseTitle}</td>
                      <td>
                        {item.isCompleted
                          ? "Process Completed"
                          : "Pending Upload/Oath"}
                      </td>
                      <td>
                        {item.docupload[0]?.schedule != null
                          ? Constants.momentDate(
                              item.docupload[0]?.schedule,
                            ).format("DD MMM, YYYY")
                          : "N/A"}
                      </td>
                      <td>
                        {item.docupload[0]?.schedule != null
                          ? Constants.momentDate(
                              item.docupload[0]?.schedule,
                            ).format("h:mm a")
                          : "N/A"}
                      </td>
                      <td>
                        {item.docupload[0]?.zoomLink != null ? (
                          <a
                            href={item.docupload[0]?.zoomLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cfo-text-link"
                          >
                            Zoom Link
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td className="cfo-swearing-btn-cell">
                        <JisButton
                          variant="plain"
                          onClick={() =>
                            navigate(
                              `/prepare-document/${item.docupload[0].id}/cfo`,
                            )
                          }
                        >
                          View Documents
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {profile.role.id === 18 && cases?.length > 0 && (
          <div className="table" style={{ marginTop: 20 }}>
            <div class="section-cases">
              <span>Deputy Sheriff Cases</span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th>L.G.A</th>
                    <th className="col-title">Address</th>
                    <th>SLA</th>
                    <th className="col-medium">Status Level</th>
                    <th className="col-title">Details</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cases?.slice(0, 6).map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.caseNumber || "N/A"}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>N/A</td>
                      <td>N/A</td>
                      <td>
                        <DeadlineBadge dateString={opt.slaExpire} />
                      </td>
                      <td>
                        {
                          Constants.getItemById(
                            frequentData?.casestatuses,
                            opt.caseStatusId,
                          )?.description
                        }{" "}
                        ||"N/A"
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onView(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                      <td>
                        <JisButton
                          onClick={() => {
                            setIsAssignModalOpen(true);
                          }}
                          variant="plain"
                        >
                          Assign
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {profile.role.id === 17 && reworkCases?.length > 0 && (
          <div className="table" style={{ marginTop: 20 }}>
            <div class="section-cases">
              <span>Screener Cases</span>
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-title">Details</th>
                  </tr>
                </thead>
                <tbody>
                  {reworkCases?.map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.referenceNumber || "N/A"}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>

                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onView(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {(profile.role.id === 22 ||
          profile.role.id === 23 ||
          profile.role.id === 28) &&
          adrAdminCases?.length > 0 && (
            <div className="table" style={{ marginTop: 20 }}>
              <div class="section-cases">
                <span>
                  {profile.role.id === 23
                    ? "ADR COORDINATOR CASES"
                    : "ADR ADMINISTRATOR CASES"}
                </span>
              </div>
              <div className="table-wrapper">
                <table class="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Date Initiated</th>
                      <th className="col-medium">Case Age</th>
                      {profile.role.id === 22 && <th>SLA</th>}
                      <th className="col-title">Details</th>
                      {profile.role.id === 22 && (
                        <th className="col-action">Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {adrAdminCases?.map((opt, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            backgroundColor: `${
                              Constants.getItemById(
                                frequentData?.casecategories,
                                opt.caseCategoryId,
                              )?.colour
                            }`,
                          }}
                        >
                          {opt.caseNumber}
                        </td>
                        <td>{opt.caseTitle}</td>
                        <td>
                          {Constants.momentDate(opt.createdOn).format(
                            "DD MMM, YYYY",
                          )}
                        </td>
                        <td>{moment().diff(opt.createdOn, "days")}</td>
                        {profile.role.id === 22 && (
                          <td>
                            <DeadlineBadge dateString={opt.slaExpire} />
                          </td>
                        )}
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onView(opt.caseId)}
                          >
                            View
                          </JisButton>
                        </td>
                        {profile.role.id === 22 && (
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onClear(opt)}
                            >
                              Clear
                            </JisButton>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        {profile.role.id === 19 && sheriffPendingCases?.length > 0 && (
          <div className="table" style={{ marginTop: 20 }}>
            <div className="section-cases">
              <span>Deputy Sheriff</span>
            </div>
            <div className="table-wrapper">
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-medium">Classification</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-medium">Status Level</th>
                    <th>SLA</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sheriffPendingCases?.map((opt, index) => (
                    <tr key={index}>
                      <td>{opt.caseNumber || "N/A"}</td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId,
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId,
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.caseStatusId,
                        )?.description || "N/A"}
                      </td>
                      <td>
                        <DeadlineBadge dateString={opt.slaExpire} />
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onView(opt.caseId, index)}
                        >
                          View
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <BackLoader open={loading} />

      {isGazette && (
        <div className={"preview open"} style={{ overflow: "scroll" }}>
          <div className="heading">
            <div className="buttongroup">
              <JisButton icon="close" onClick={() => setIsGazette(false)}>
                {" "}
                Close Preview
              </JisButton>
            </div>
          </div>

          <Gazette
            filingtypeid={active.case.caseFilingId}
            levelid={active.case.caseCategoryId}
            feetypeid={FeeTYPEID}
            token={token}
            onProceed={(e) => onGazetteProceed(e)}
            caseid={active.caseId}
            feeId={active.id}
            isShowAll
          >
            <div className="top-nav">
              <div className="left-top">
                <div className="top">
                  <h2>
                    {active.case.caseNumber ?? active.case.referenceNumber} |{" "}
                    {
                      Constants.getItemById(
                        frequentData.casecategories,
                        active.case.caseCategoryId,
                      )?.categoryTitle
                    }
                  </h2>
                </div>
                <p>Select items related to the case that you are filing</p>
              </div>
              <p className="nav-status">Review Fees /Specifications</p>
            </div>
          </Gazette>

          <div className="date-btns"></div>
        </div>
      )}

      {openClear && (
        <JisDialogForm title="Clear Case" onClose={() => setOpenClear(false)}>
          <form onSubmit={onSaveClear}>
            <h4 className="suit-number-header">
              Suit number:{" "}
              <span style={{ fontWeight: 400 }}>{active?.caseNumber}</span>
            </h4>

            <div className="input-group">
              <CommentDropdown
                placeholder="comment"
                required={true}
                reasonPlaceHolder={"Reason (select all that apply)"}
                onChange={(e) => setClearComment(e.target.value)}
                name="clearComment"
              />
            </div>
            <div className="clear-case-button-group">
              <JisButton
                variant="plain"
                type="button"
                onClick={() => setOpenClear(false)}
              >
                Cancel
              </JisButton>
              <JisButton type="submit">Save</JisButton>
            </div>
          </form>
        </JisDialogForm>
      )}

      {openOption && (
        <ClearOptionsModal
          setOpenOption={setOpenOption}
          onSave={onSave}
          active={active}
          isLiti={isLiti}
          setIsLitiation={setIsLitiation}
          isRework={isRework}
          setIsRework={setIsRework}
          processMode={processMode}
          setProcessMode={setProcessMode}
          option={option}
          onOptionChange={onOptionChange}
          frequentData={frequentData}
          claimTypes={claimTypes}
          selectedClaimTypes={selectedClaimTypes}
          setSelectedClaimTypes={setSelectedClaimTypes}
          documents={documents}
          onPreviewDoc={onPreviewDoc}
          rework_handleChange={rework_handleChange}
          err={err}
          onGenerateNumber={onGenerateNumber}
          suitNumber={suitNumber}
        />
      )}
      {isAssignModalOpen && (
        <div className="service_sheriff_wrapper">
          <div className="service_sheriff_bg_image">
            <div className="service_sheriff_modal">
              <p className="header">Assign To Service Sheriff</p>
              <form onSubmit={assignDsCase}>
                <div className="bulk_assignment_form_wrapper">
                  <div className="form_right_content">
                    <div>
                      {/* {Object.keys(selectedCases).length <= 1 && (
                        <div className="select-group">
                          <label>Suit Number</label>
                          <input
                            type="text"
                            readOnly
                            value={
                              selectedCases[Object.keys(selectedCases)[0]]
                                ?.caseNumber || ""
                            }
                          />
                        </div>
                      )} */}

                      <div className="select-group">
                        <label>Service Sheriff</label>
                        <select
                          name="roleId"
                          value={option.roleId}
                          onChange={onOptionChange}
                          required
                        >
                          <option value="">Select service sheriff </option>
                          {sheriffs?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.suffix} {opt.firstName} {opt.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* <div className="input-group">
                      <label>Comment</label>
                      <div>
                        {" "}
                        <textarea
                          placeholder=" Comment"
                          name="comment"
                          required={true}
                          value={option.comment}
                          onChange={onOptionChange}
                          className="bulk_comment_textarea"
                        />
                      </div>
                    </div> */}
                    <div className="input-group">
                      <CommentDropdown
                        placeholder="comment"
                        required={true}
                        reasonPlaceHolder={"Reason (select all that apply)"}
                        onChange={onOptionChange}
                        name="clearComment"
                      />
                    </div>
                    {err != "" && <div className="error">{err}</div>}
                    <button
                      type="button"
                      className="bulk_cancel_btn"
                      onClick={() => setIsAssignModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button className="bulk_assign_btn" type="submit">
                      Assign{" "}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {openCreatePayerIdModal && (
        <div className="PayerIdModal">
          <div>
            <p className="title"> payer id not found </p>
            <p className="description">
              Generate a payer id to contiune using this site
            </p>
            <div className="button-wrap">
              <Link to="/profile">Generate a payer id </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
